// @ts-ignore
const styles = '*{box-sizing:border-box}slot.skapa-empty{pointer-events:none}:host{display:block;position:relative}.header{--skapa-modal-header-default-padding:0.5rem;color:rgb(var(--colour-text-and-icon-1,17,17,17));display:flex;flex-direction:row;padding:var(--skapa-modal-header-padding,var(--skapa-modal-header-default-padding));position:relative;width:100%}.header slot[name]{--skapa-focus-ring-internal:rgb(var(--colour-neutral-1,255,255,255));--skapa-focus-ring-external:rgb(var(--colour-neutral-7,17,17,17));display:block;flex-basis:2.5rem;min-width:2.5rem}.header slot:not([name]){margin:0 .5rem}:host([floating]) .header{--skapa-modal-header-default-padding:1rem;position:absolute}:host([floating]) slot:not([name]){visibility:hidden}slot:not([name]){align-items:center;display:flex;flex-grow:1;font-weight:700;justify-content:center;text-align:center}@media (min-width:37.5em){.header{--skapa-modal-header-default-padding:1rem}:host([floating]) .header{--skapa-modal-header-default-padding:1.5rem}}';
import SkapaElement from '@ingka/skapa-webc-element';
import { html, SlotTools } from '@ingka/webc-tools';
import '@ingka/icon-webc';
import '@ingka/button-webc';
import '@ingka/icon-store/cross';
import '@ingka/icon-store/arrow-left';
let template;
function getTemplate() {
    if (!template) {
        template = document.createElement('template');
        template.innerHTML = html `
      <style>${styles}</style>
      <div class="header" part="header">
        <slot name="back-button"></slot>
        <slot></slot>
        <slot name="close-button">
          <skapa-icon-button variant=primary inverse size="small">
            <skapa-icon icon="cross" slot="icon"></skapa-icon>
            <slot name="closebutton-label" role="none">Close dialog</slot>
          </skapa-icon-button>
        </slot>
      </div>
    `;
    }
    return template;
}
export class ModalHeader extends SkapaElement {
    constructor() {
        super();
        this.handleInteraction = (ev) => {
            const composedPath = ev.composedPath();
            if (composedPath.includes(this.closebuttonSlot)) {
                this.dispatchEvent(new Event('closerequest', { bubbles: true, composed: true }));
            }
            else if (composedPath.includes(this.backbuttonSlot)) {
                this.dispatchEvent(new Event('backrequest'));
            }
        };
        this.gatherProperties(['floating'], this);
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.append(getTemplate().content.cloneNode(true));
        this.closebuttonSlot = shadow.querySelector('[name=close-button]');
        this.backbuttonSlot = shadow.querySelector('[name=back-button]');
    }
    connectedCallback() {
        super.connectedCallback();
        Array.from(this.shadowRoot.querySelectorAll('slot')).map(SlotTools.checkSlot);
        this.shadowRoot.addEventListener('slotchange', SlotTools.slotChange);
        this.addEventListener('click', this.handleInteraction);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.shadowRoot.removeEventListener('slotchange', SlotTools.slotChange);
        this.removeEventListener('click', this.handleInteraction);
    }
    get floating() {
        return this.hasAttribute('floating');
    }
    set floating(value) {
        this.toggleAttribute('floating', !!value);
    }
}
